import React, { FC, SyntheticEvent, useState } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { ComplaintsType } from 'api/complaints/complaintsApi'
import { VoidHandler } from 'common/types'
import { Slot } from 'components/designSystem/Slot/Slot'

import { StareShareComplaint } from './StartShareComplaint'
import { ComplainList } from '../Complaints/ComplainList'
import { SharingType } from '../SharingContent/SharingContent.constant'
import { SharingContent } from '../SharingContent/SharingContentIndex'

export type Step = 'common' | 'share' | 'complaints-start' | 'complaints-end'

export const ParentShareComplaints: FC<{
  profileId: number
  onCallback?: VoidHandler
  onClose?: VoidHandler
}> = ({ profileId, onCallback, onClose }) => {
  const [step, setStep] = useState<Step>('common')

  const handleClick = (event: SyntheticEvent, step: Step) => {
    event.stopPropagation()
    event.preventDefault()
    setStep(step)
  }

  const handleCallbackComplaintSend = () => {
    onCallback?.()
    onClose?.()
  }

  return (
    <>
      <Slide className={cx(step === 'common' && activeCss)}>
        <Slot type="vertical">
          <StareShareComplaint
            onComplainsClick={(event) => handleClick(event, 'complaints-start')}
            onShareClick={(event) => handleClick(event, 'share')}
          />
        </Slot>
      </Slide>
      <Slide className={cx(step === 'share' && activeCss)}>
        <Slot type="vertical">
          <SharingContent
            type={SharingType.profile}
            contentId={profileId}
            profileId={profileId}
            hasNewDesign={true}
          />
        </Slot>
      </Slide>
      <Slide className={cx(step === 'complaints-start' && activeCss)}>
        <ComplainList
          violatorId={profileId}
          complaintListType={ComplaintsType.profile}
          complaintType={ComplaintsType.profile}
          entityId={profileId}
          actionAfterComplainSend={handleCallbackComplaintSend}
          showRedesignComplaints={true}
        />
      </Slide>
    </>
  )
}

const Slide = styled.div`
  visibility: hidden;
  height: 0;
  opacity: 0;
  pointer-events: none;
  min-width: 0;
  width: 0;
  font-size: 0;
  transition: opacity 0.3s ease-in-out;
  white-space: nowrap;
`

const activeCss = css`
  visibility: visible;
  height: auto;
  width: auto;
  opacity: 1;
  pointer-events: auto;
  font-size: inherit;
`
